<template>
	<section style="padding:15px;">
		<template v-if="Object.keys(selectedStudent).length > 0">
			<div v-if="dataIsLoaded">
				<!-- Start of Student Information section -->
				<div class="row" v-if="selectedStudent.RESTRICTED_ACCOUNT_FLG !== 'Y'">
					<div class="col-xs-6 col-xs-offset-3" style="text-align: center;">
						<h3>
							{{ $t( `${getHeaderTitle(1)}` ) }}
						</h3>
					</div>
					<div class="col-xs-12 col-md-4"
								style="min-height: 110px;"
								v-for="(column, columnIndex) in studentDataFields.GROUPS['1'].C_ARRAY"
								:key="`displayOptions_${columnIndex}`">
						<div class="row">
							<div class="col-xs-12">
								<template v-if="!!studentDataFields.GROUPS['1'].COLUMNS[column].HELP_TEXT">
									<font-awesome-icon icon="question-circle"
																			v-tooltip.top-center="{content: studentDataFields.GROUPS['1'].COLUMNS[column].HELP_TEXT, trigger: 'hover click'}">
									</font-awesome-icon>
								</template>
								<div :class="{'changeRequest': false}" style="font-weight: bold; display: inline;">
									<!-- Check if column exists within studentDataFieldLabels.js in case a new field for student info -->
									<!-- is added in the DB and not updated in file and added to locale file and the -->
									<!-- studentDataFieldLabels.js -->
									<!-- When adding a new field to the DB, developer would need to update the locale files,  -->
									<template v-if="!!STUDENTTEXT[ column ]">
										<!-- This check verifies that the string length of the name value pair in the JSON object file -->
										<!-- has text and that the translated text also exists. -->
										<template v-if="STUDENTTEXT[ column ].length > 0 && ( $t( STUDENTTEXT[ column ] ) ).length > 0">
											{{ $t( STUDENTTEXT[ column ] ) }}
										</template>
										<template v-else>
											{{ studentDataFields.GROUPS[ '1' ].COLUMNS[ column ].FIELD_LABEL }}
										</template>
									</template>
									<template v-else>
										{{ studentDataFields.GROUPS[ '1' ].COLUMNS[ column ].FIELD_LABEL }}
									</template>
								</div>
							</div>
						</div>
						<template v-if="studentDataFields.GROUPS['1'].COLUMNS[column].SAP_FIELD.includes('FLG')">
							<div class="row">
								<div class="col-xs-12">
									<div class="row">
										<sapphire-toggle class="col-xs-6 col-md-4 col-lg-3"
																		v-model="formFieldSelectedValues.STUDENT[studentDataFields.GROUPS['1'].COLUMNS[column].SAP_FIELD].VALUE"
																		:disabled="!!disabledMap[1].includes(studentDataFields.GROUPS['1'].COLUMNS[column].SAP_FIELD_RID)"
																		:aria-label="`${studentDataFields.GROUPS['1'].DV_GROUP_DESC}, ${studentDataFields.GROUPS['1'].COLUMNS[column].FIELD_LABEL}, ${formFieldSelectedValues.STUDENT[studentDataFields.GROUPS['1'].COLUMNS[column].SAP_FIELD].VALUE}`"
																		@input="saveChangedValue(formFieldSelectedValues.STUDENT[studentDataFields.GROUPS['1'].COLUMNS[column].SAP_FIELD])">
										</sapphire-toggle>
									</div>
								</div>
							</div>
							<div class="row" v-if="formFieldSelectedValues.STUDENT[studentDataFields.GROUPS['1'].COLUMNS[column].SAP_FIELD].VALUE !== formFieldSelectedValues.STUDENT[studentDataFields.GROUPS['1'].COLUMNS[column].SAP_FIELD].OLD_VALUE">
								<div class="col-xs-12 current"
										 v-tooltip.top-center="{content: $t('MAIN_CONTENT.ChangeStudentData.schoolNotificationMessage'), trigger: 'hover click'}">
									<font-awesome-icon icon="exclamation-triangle"></font-awesome-icon>
									{{
										$t(
											'MAIN_CONTENT.ChangeStudentData.currentWithColon',
											{
												choice: formFieldSelectedValues.STUDENT[studentDataFields.GROUPS['1'].COLUMNS[column].SAP_FIELD].OLD_VALUE === 'Y' ?
													$t('MAIN_CONTENT.commonContent.yesLabel') :
													$t('MAIN_CONTENT.commonContent.noLabel')
											}
										)
									}} 
								</div>
							</div>
						</template>
						<template v-else-if="studentDataFields.GROUPS['1'].COLUMNS[column].USE_CODEX.length > 0">
							<div class="row">
								<div class="col-xs-12">
									<select v-model="formFieldSelectedValues.STUDENT[studentDataFields.GROUPS['1'].COLUMNS[column].SAP_FIELD].VALUE"
													class="form-control"
													:aria-label="`${studentDataFields.GROUPS['1'].DV_GROUP_DESC}, ${studentDataFields.GROUPS['1'].COLUMNS[column].FIELD_LABEL}, ${formFieldSelectedValues.STUDENT[studentDataFields.GROUPS['1'].COLUMNS[column].SAP_FIELD].VALUE}`"
													:disabled="!!disabledMap[1].includes(studentDataFields.GROUPS['1'].COLUMNS[column].SAP_FIELD_RID)">
										<option v-for="(codex, key) in studentDataCodex[studentDataFields.GROUPS['1'].COLUMNS[column].USE_CODEX]"
														:key="`CODEX_${key}`"
														:value="codex.DICT_CODE">
											{{ codex.DICT_DESC }}
										</option>
									</select>
								</div>
							</div>
							<div class="row" v-if="formFieldSelectedValues.STUDENT[studentDataFields.GROUPS['1'].COLUMNS[column].SAP_FIELD].VALUE !== formFieldSelectedValues.STUDENT[studentDataFields.GROUPS['1'].COLUMNS[column].SAP_FIELD].OLD_VALUE">
								<div class="col-xs-12 current"
									v-tooltip.top-center="{content: $t('MAIN_CONTENT.ChangeStudentData.schoolNotificationMessage'), trigger: 'hover click'}">
								<font-awesome-icon icon="exclamation-triangle"></font-awesome-icon>
								{{
									$t(
									'MAIN_CONTENT.ChangeStudentData.currentWithColon',
									{
										choice: formFieldSelectedValues.STUDENT[studentDataFields.GROUPS['1'].COLUMNS[column].SAP_FIELD].OLD_VALUE.length === 0
										? '\" \"'
										: (studentDataCodex[studentDataFields.GROUPS['1'].COLUMNS[column].USE_CODEX] &&
											studentDataCodex[studentDataFields.GROUPS['1'].COLUMNS[column].USE_CODEX][formFieldSelectedValues.STUDENT[studentDataFields.GROUPS['1'].COLUMNS[column].SAP_FIELD].OLD_VALUE] &&
											studentDataCodex[studentDataFields.GROUPS['1'].COLUMNS[column].USE_CODEX][formFieldSelectedValues.STUDENT[studentDataFields.GROUPS['1'].COLUMNS[column].SAP_FIELD].OLD_VALUE].DICT_DESC) || ""
									}
									)
								}}
								</div>
							</div>
						</template>
						<template v-else>
							<div class="row">
								<div class="col-xs-12">
									<input type="text"
												:maxlength="`${studentDataFields.GROUPS['1'].COLUMNS[column].FIELD_LENGTH}`"
												class="form-control"
												v-model="formFieldSelectedValues.STUDENT[studentDataFields.GROUPS['1'].COLUMNS[column].SAP_FIELD].VALUE"
												v-if="!isEmail(studentDataFields.GROUPS['1'].COLUMNS[column].SAP_FIELD)"
												:aria-label="`${studentDataFields.GROUPS['1'].DV_GROUP_DESC}, ${studentDataFields.GROUPS['1'].COLUMNS[column].FIELD_LABEL}, ${formFieldSelectedValues.STUDENT[studentDataFields.GROUPS['1'].COLUMNS[column].SAP_FIELD].VALUE}`"
												:disabled="!!disabledMap[1].includes(studentDataFields.GROUPS['1'].COLUMNS[column].SAP_FIELD_RID)"
												@change="saveChangedValue(formFieldSelectedValues.STUDENT[studentDataFields.GROUPS['1'].COLUMNS[column].SAP_FIELD])" />
									<ValidationProvider :name="studentDataFields.GROUPS['1'].COLUMNS[column].FIELD_LABEL"
																			rules="email">
										<div slot-scope="{ errors }">
											<input type="text"
														:maxlength="`${studentDataFields.GROUPS['1'].COLUMNS[column].FIELD_LENGTH}`"
														class="form-control"
														:aria-label="`${studentDataFields.GROUPS['1'].DV_GROUP_DESC}, ${studentDataFields.GROUPS['1'].COLUMNS[column].FIELD_LABEL}, ${formFieldSelectedValues.STUDENT[studentDataFields.GROUPS['1'].COLUMNS[column].SAP_FIELD].VALUE}`"
														v-model="formFieldSelectedValues.STUDENT[studentDataFields.GROUPS['1'].COLUMNS[column].SAP_FIELD].VALUE"
														:disabled="!!disabledMap[1].includes(studentDataFields.GROUPS['1'].COLUMNS[column].SAP_FIELD_RID)"
														v-if="isEmail(studentDataFields.GROUPS['1'].COLUMNS[column].SAP_FIELD)"
														@change="isEmailFormat(formFieldSelectedValues.STUDENT[studentDataFields.GROUPS['1'].COLUMNS[column].SAP_FIELD])" />
											<small class="text-danger">{{ errors[0] }}</small>
										</div>
									</ValidationProvider>
								</div>
							</div>
							<div class="row" v-if="formFieldSelectedValues.STUDENT[studentDataFields.GROUPS['1'].COLUMNS[column].SAP_FIELD].VALUE !== formFieldSelectedValues.STUDENT[studentDataFields.GROUPS['1'].COLUMNS[column].SAP_FIELD].OLD_VALUE">
								<div class="col-xs-12 current"
										 v-tooltip.top-center="{content: $t('MAIN_CONTENT.ChangeStudentData.schoolNotificationMessage'), trigger: 'hover click'}">
									<font-awesome-icon icon="exclamation-triangle"></font-awesome-icon>
									{{
										$t(
											'MAIN_CONTENT.ChangeStudentData.currentWithColon',
											{
												choice: formFieldSelectedValues.STUDENT[studentDataFields.GROUPS['1'].COLUMNS[column].SAP_FIELD].OLD_VALUE.length === 0 ?
													'\" \"' :
													formFieldSelectedValues.STUDENT[studentDataFields.GROUPS['1'].COLUMNS[column].SAP_FIELD].OLD_VALUE
											}
										)
									}} 
								</div>
							</div>
						</template>
					</div>
				</div>
				<!-- End of Student Information section -->

				<!-- Start of Student Contact Information section -->
				<div class="row">
					<div class="col-xs-6 col-xs-offset-3" style="text-align: center;">
						<h3 v-if="!!studentDataFields.GROUPS['2'].DV_GROUP_DESC">
							{{ $t( `${getHeaderTitle(2)}` ) }}
						</h3>
					</div>
				</div>
				<div class="row"
						v-for="(contact, contactIndex) in formFieldSelectedValues.ORDER"
						:key="`contacts_data_${contactIndex}`">

					<panel-basic :title="`${formFieldSelectedValues.CONTACTS[contact].DETAILS.CONTACT_DESC} - ${formFieldSelectedValues.CONTACTS[contact].DETAILS.FIRST_NAME} ${formFieldSelectedValues.CONTACTS[contact].DETAILS.LAST_NAME}`"
												:id="`contacts_${contactIndex}`"
												:collapsable="true"
												class="contact-header"
												:class="{'rounded-top': contactIndex === 0}"
												panel-class="full-height">
						<template slot="title">
							{{ formFieldSelectedValues.CONTACTS[contact].DETAILS.CONTACT_DESC }} - {{ formFieldSelectedValues.CONTACTS[contact].DETAILS.FIRST_NAME }} {{ formFieldSelectedValues.CONTACTS[contact].DETAILS.LAST_NAME }}
						</template>
						<div class="col-xs-12 col-md-4"
								style="min-height: 110px;"
								v-for="(column, columnIndex) in contactFieldOrderArray"
								v-if="!(column === 18 || column === 17)"
								:key="`contact_${columnIndex}`">
							<div class="row">
								<div class="col-xs-12" style="font-weight: bold; display: inline;">
									<font-awesome-icon icon="question-circle"
																			v-if="!!studentDataFields.GROUPS['2'].COLUMNS[column].HELP_TEXT"
																			v-tooltip.top-center="{content: studentDataFields.GROUPS['2'].COLUMNS[column].HELP_TEXT, trigger: 'hover click'}">
									</font-awesome-icon>
									<!-- Check if column exists within studentDataFieldLabels.js in case a new field for student contact -->
									<!-- info is added in the DB and not updated in file and added to locale file and the -->
									<!-- studentDataFieldLabels.js -->
									<template v-if="!!CONTACTSTEXT[ column ]">
										<!-- This check verifies that the string length of the name value pair in the JSON object file -->
										<!-- has text and that the translated text also exists. -->
										<template v-if="CONTACTSTEXT[ column ].length > 0 && ( $t( CONTACTSTEXT[ column ] ) ).length > 0">
											{{ $t( CONTACTSTEXT[ column ] ) }}
										</template>
										<template v-else>
											{{ studentDataFields.GROUPS['2'].COLUMNS[column].FIELD_LABEL }}
										</template>
									</template>
									<template v-else>
										{{ studentDataFields.GROUPS['2'].COLUMNS[column].FIELD_LABEL }}
									</template>
								</div>
							</div>

							<template v-if="studentDataFields.GROUPS['2'].COLUMNS[column].SAP_FIELD.includes('FLG')">
								<div class="row">
									<div class="col-xs-12">
										<div class="row">
											<sapphire-toggle class="col-xs-6 col-md-4 col-lg-3"
																			v-model="formFieldSelectedValues.CONTACTS[contact][studentDataFields.GROUPS['2'].COLUMNS[column].SAP_FIELD].VALUE"
																			:disabled="!!disabledMap[2].includes(studentDataFields.GROUPS['2'].COLUMNS[column].SAP_FIELD_RID)"
																			:aria-label="`Student contact ${formFieldSelectedValues.CONTACTS[contact].DETAILS.CONTACT_DESC} - ${formFieldSelectedValues.CONTACTS[contact].DETAILS.FIRST_NAME} ${formFieldSelectedValues.CONTACTS[contact].DETAILS.LAST_NAME}, ${studentDataFields.GROUPS['2'].COLUMNS[column].FIELD_LABEL}, ${formFieldSelectedValues.CONTACTS[contact][studentDataFields.GROUPS['2'].COLUMNS[column].SAP_FIELD].VALUE}`"
																			@input="saveChangedValue(formFieldSelectedValues.CONTACTS[contact][studentDataFields.GROUPS['2'].COLUMNS[column].SAP_FIELD])">
											</sapphire-toggle>
										</div>
									</div>
								</div>
								<div class="row" v-if="formFieldSelectedValues.CONTACTS[contact][studentDataFields.GROUPS['2'].COLUMNS[column].SAP_FIELD].VALUE !== formFieldSelectedValues.CONTACTS[contact][studentDataFields.GROUPS['2'].COLUMNS[column].SAP_FIELD].OLD_VALUE">
									<div class="col-xs-12 current"
											 v-tooltip.top-center="{content: $t('MAIN_CONTENT.ChangeStudentData.schoolNotificationMessage'), trigger: 'hover click'}">
										<font-awesome-icon icon="exclamation-triangle"></font-awesome-icon>
										{{
											$t(
												'MAIN_CONTENT.ChangeStudentData.currentWithColon',
												{
													choice: formFieldSelectedValues.CONTACTS[contact][studentDataFields.GROUPS['2'].COLUMNS[column].SAP_FIELD].OLD_VALUE === 'Y' ?
														$t('MAIN_CONTENT.commonContent.yesLabel') :
														$t('MAIN_CONTENT.commonContent.noLabel')
												}
											)
										}}
									</div>
								</div>
							</template>
							<template v-else-if="studentDataFields.GROUPS['2'].COLUMNS[column].USE_CODEX.length > 0">
								<div class="row">
									<div class="col-xs-12">
										<select v-model="formFieldSelectedValues.CONTACTS[contact][studentDataFields.GROUPS['2'].COLUMNS[column].SAP_FIELD].VALUE"
														class="form-control"
														:aria-label="`Student contact ${formFieldSelectedValues.CONTACTS[contact].DETAILS.CONTACT_DESC} - ${formFieldSelectedValues.CONTACTS[contact].DETAILS.FIRST_NAME} ${formFieldSelectedValues.CONTACTS[contact].DETAILS.LAST_NAME}, ${studentDataFields.GROUPS['2'].COLUMNS[column].FIELD_LABEL}, ${formFieldSelectedValues.CONTACTS[contact][studentDataFields.GROUPS['2'].COLUMNS[column].SAP_FIELD].VALUE}`"
														:disabled="!!disabledMap[2].includes(studentDataFields.GROUPS['2'].COLUMNS[column].SAP_FIELD_RID)"
														@change="saveChangedValue(formFieldSelectedValues.CONTACTS[contact][studentDataFields.GROUPS['2'].COLUMNS[column].SAP_FIELD])">
											<option v-for="(codex, key) in studentDataCodex[studentDataFields.GROUPS['2'].COLUMNS[column].USE_CODEX]"
															:key="`CODEX_${key}`"
															:value="codex.DICT_CODE">
												{{ codex.DICT_DESC }}
											</option>
										</select>
									</div>
								</div>
								<div class="row" v-if="formFieldSelectedValues.CONTACTS[contact][studentDataFields.GROUPS['2'].COLUMNS[column].SAP_FIELD].VALUE !== formFieldSelectedValues.CONTACTS[contact][studentDataFields.GROUPS['2'].COLUMNS[column].SAP_FIELD].OLD_VALUE">
									<div class="col-xs-12 current"
										v-tooltip.top-center="{content: $t('MAIN_CONTENT.ChangeStudentData.schoolNotificationMessage'), trigger: 'hover click'}">
									<font-awesome-icon icon="exclamation-triangle"></font-awesome-icon>
									{{
										$t(
										'MAIN_CONTENT.ChangeStudentData.currentWithColon',
										{
											choice: formFieldSelectedValues.CONTACTS[contact][studentDataFields.GROUPS['2'].COLUMNS[column].SAP_FIELD].OLD_VALUE.length === 0
											? '\" \"'
											: (studentDataCodex[studentDataFields.GROUPS['2'].COLUMNS[column].USE_CODEX] &&
												studentDataCodex[studentDataFields.GROUPS['2'].COLUMNS[column].USE_CODEX][formFieldSelectedValues.CONTACTS[contact][studentDataFields.GROUPS['2'].COLUMNS[column].SAP_FIELD].OLD_VALUE] &&
												studentDataCodex[studentDataFields.GROUPS['2'].COLUMNS[column].USE_CODEX][formFieldSelectedValues.CONTACTS[contact][studentDataFields.GROUPS['2'].COLUMNS[column].SAP_FIELD].OLD_VALUE].DICT_DESC) || ""
										}
										)
									}}
									</div>
								</div>
							</template>
							<template v-else>
								<div class="row">
									<div class="col-xs-12">
										<input type="number"
											min="1"
											max="99"
											style="width: 75px;"
											:maxlength="`${studentDataFields.GROUPS['2'].COLUMNS[column].FIELD_LENGTH}`"
											class="form-control"
											:aria-label="`Student contact ${formFieldSelectedValues.CONTACTS[contact].DETAILS.CONTACT_DESC} - ${formFieldSelectedValues.CONTACTS[contact].DETAILS.FIRST_NAME} ${formFieldSelectedValues.CONTACTS[contact].DETAILS.LAST_NAME}, ${studentDataFields.GROUPS['2'].COLUMNS[column].FIELD_LABEL}, ${formFieldSelectedValues.CONTACTS[contact][studentDataFields.GROUPS['2'].COLUMNS[column].SAP_FIELD].VALUE}`"
											v-model="formFieldSelectedValues.CONTACTS[contact][studentDataFields.GROUPS['2'].COLUMNS[column].SAP_FIELD].VALUE"
											:disabled="!!disabledMap[2].includes(studentDataFields.GROUPS['2'].COLUMNS[column].SAP_FIELD_RID)"
											v-if="studentDataFields.GROUPS['2'].COLUMNS[column].SAP_FIELD.indexOf('_ECO') >= 0"
											@change="saveChangedValue(formFieldSelectedValues.CONTACTS[contact][studentDataFields.GROUPS['2'].COLUMNS[column].SAP_FIELD])" />

										<input :type="studentDataFields.GROUPS['2'].COLUMNS[column].SAP_FIELD.indexOf('_ECO') >= 0 ? `number`: `text`"
											min="1"
											max="99"
											:maxlength="`${studentDataFields.GROUPS['2'].COLUMNS[column].FIELD_LENGTH}`"
											class="form-control"
											:aria-label="`Student contact ${formFieldSelectedValues.CONTACTS[contact].DETAILS.CONTACT_DESC} - ${formFieldSelectedValues.CONTACTS[contact].DETAILS.FIRST_NAME} ${formFieldSelectedValues.CONTACTS[contact].DETAILS.LAST_NAME}, ${studentDataFields.GROUPS['2'].COLUMNS[column].FIELD_LABEL}, ${formFieldSelectedValues.CONTACTS[contact][studentDataFields.GROUPS['2'].COLUMNS[column].SAP_FIELD].VALUE}`"
											v-model="formFieldSelectedValues.CONTACTS[contact][studentDataFields.GROUPS['2'].COLUMNS[column].SAP_FIELD].VALUE"
											:disabled="!!disabledMap[2].includes(studentDataFields.GROUPS['2'].COLUMNS[column].SAP_FIELD_RID)"
											v-else-if="!isEmail(studentDataFields.GROUPS['2'].COLUMNS[column].SAP_FIELD)"
											@change="saveChangedValue(formFieldSelectedValues.CONTACTS[contact][studentDataFields.GROUPS['2'].COLUMNS[column].SAP_FIELD])" />
										<ValidationProvider :name="studentDataFields.GROUPS['2'].COLUMNS[column].FIELD_LABEL"
																				rules="email">
											<div slot-scope="{ errors }">
												<input type="text"
															:maxlength="`${studentDataFields.GROUPS['2'].COLUMNS[column].FIELD_LENGTH}`"
															class="form-control"
															:aria-label="`Student contact ${formFieldSelectedValues.CONTACTS[contact].DETAILS.CONTACT_DESC} - ${formFieldSelectedValues.CONTACTS[contact].DETAILS.FIRST_NAME} ${formFieldSelectedValues.CONTACTS[contact].DETAILS.LAST_NAME}, ${studentDataFields.GROUPS['2'].COLUMNS[column].FIELD_LABEL}, ${formFieldSelectedValues.CONTACTS[contact][studentDataFields.GROUPS['2'].COLUMNS[column].SAP_FIELD].VALUE}`"
															v-model="formFieldSelectedValues.CONTACTS[contact][studentDataFields.GROUPS['2'].COLUMNS[column].SAP_FIELD].VALUE"
															:disabled="!!disabledMap[2].includes(studentDataFields.GROUPS['2'].COLUMNS[column].SAP_FIELD_RID)"
															v-if="isEmail(studentDataFields.GROUPS['2'].COLUMNS[column].SAP_FIELD)"
															@change="isEmailFormat(formFieldSelectedValues.CONTACTS[contact][studentDataFields.GROUPS['2'].COLUMNS[column].SAP_FIELD])" />
												<small class="text-danger">{{ errors[0] }}</small>
											</div>
										</ValidationProvider>
									</div>
								</div>
								<div class="row" v-if="formFieldSelectedValues.CONTACTS[contact][studentDataFields.GROUPS['2'].COLUMNS[column].SAP_FIELD].VALUE !== formFieldSelectedValues.CONTACTS[contact][studentDataFields.GROUPS['2'].COLUMNS[column].SAP_FIELD].OLD_VALUE">
									<div class="col-xs-12 current"
											v-tooltip.top-center="{content: $t('MAIN_CONTENT.ChangeStudentData.schoolNotificationMessage'), trigger: 'hover click'}">
										<font-awesome-icon icon="exclamation-triangle"></font-awesome-icon>
										<template>
											{{
												$t(
													'MAIN_CONTENT.ChangeStudentData.currentWithColon',
													{
														choice: formFieldSelectedValues.CONTACTS[contact][studentDataFields.GROUPS['2'].COLUMNS[column].SAP_FIELD].OLD_VALUE
													}
												)
											}}
										</template>
									</div>
								</div>
							</template>
							<br :key="`contacts_br_${contactIndex}`" />
						</div>
					</panel-basic>
				</div>
				<!-- End of Student Contact Information section -->
			</div>
		</template>
		<template v-else>
			{{ $t('MAIN_CONTENT.commonContent.noStudentHasBeenSelectedWithPeriod') }}
		</template>
	</section>
</template>

<script>
	import { mapGetters } from 'vuex';
	import { ValidationProvider } from 'vee-validate';

	import CONTACTSTEXT from './studentDataFieldLabels.js';
	import STUDENTTEXT from './studentDataFieldLabels.js';

	import StudentData from '../../api/StudentData';

	import PanelBasic from 'COMMONS/panels/PanelBasic.vue';
	import SapphireToggle from 'COMMONS/SapphireToggle/SapphireToggle.vue';

	export default {
		name: 'ChangeStudentData',
		data() {
			return {
				...STUDENTTEXT,
				...CONTACTSTEXT,
				studentDataCodex: {},
				studentDataFields: {},
				formFieldSelectedValues: {},
				changeRequestData: {},
				changedFields: [],
				changedFields: [],
				invalidEmailErrors: [],
				disabledMap: {
					1: [],
					2: []
				},
				dataIsLoaded: false
			};
		},
		computed: {
			...mapGetters(['selectedStudent', 'role', 'roleRules']),
			contactFieldOrderArray(){
				 return this.studentDataFields.GROUPS['2'].C_ARRAY.filter( (v) => !(v===17 || v===18));
			},
		},
		components: {
			ValidationProvider,
			PanelBasic,
			SapphireToggle
		},
		methods: {
			fetchStudentData() {
				const self = this;

				let studentData = new StudentData({
					route: 'data-verification-forms/student-data-form',
					query: {
						student_rid: this.selectedStudent.STUDENT_RID
					}
				});

				const promise = studentData.get();

				promise.then(response => {
					self.$set(self, 'studentDataFields', response.data.data.FIELDS);
					self.$set(self, 'studentDataCodex', response.data.data.CODEXES);

					self.loadFormFieldValues();
				});
			},
			loadFormFieldValues() {
				const self = this;

				let studentData = new StudentData({
					route: 'data-verification-forms/student-data-form-values',
					query: {
						student_rid: this.selectedStudent.STUDENT_RID
					}
				});

				const promise = studentData.get();

				promise.then(response => {
					self.$set(self, 'formFieldSelectedValues', response.data.data);
					self.dataIsLoaded = true;
				});
			},
			saveChangedValue(valueObj) {
				const self = this;
				
				let type = !!valueObj.PERSON_GUID ? 2 : 1;

				if(!self.disabledMap[type].includes(valueObj.SAP_FIELD_RID)) {
					self.disabledMap[type].push(valueObj.SAP_FIELD_RID);
				}
				try{
					let fieldName = this.studentDataFields.GROUPS[valueObj.DV_GROUP_RID].COLUMNS[valueObj.SAP_FIELD_RID].SAP_FIELD;
					if(fieldName.indexOf('_ECO') >= 0){
						if(valueObj.VALUE.length){
							if(valueObj.VALUE <= 0){
								valueObj.VALUE = 1;
							}
							if(valueObj.VALUE >= 99){
								valueObj.VALUE = 99;
							}
						}
					}
				}catch(e){

				}
				

				let studentData = new StudentData({
					route: 'data-verification-forms/student-data-form-change-requests',
					query: {
						student_rid: this.selectedStudent.STUDENT_RID
					},
					data: valueObj
				});

				const promise = studentData.post();

				promise.then(response => {
					let index = self.disabledMap[type].indexOf(valueObj.SAP_FIELD_RID);

					self.disabledMap[type].splice(index, 1);
				});
			},
			isEmail(field) {
				return field === 'EMAIL_ADDRESS_1' ||
							 field === 'EMAIL_ADDRESS_2' ||
							 field === 'EMAIL_ADDRESS_3' ||
							 field === 'EMAIL_ADDRESS';
			},
			isEmailFormat(email) {
				const regexValue = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
				let emailValue = email.VALUE;
				if(emailValue.toString().trim().length === 0 || regexValue.test(String(emailValue).toLowerCase())) {
					this.saveChangedValue(email);
				} else {
					this.invalidEmailErrors.push(email);
				}
			},
			isWithoutEmailError(field) {
				let hasEmailError = false;

				for(let e in this.invalidEmailErrors) {
					let email = this.invalidEmailErrors[e];

					if(field === email) {
						hasEmailError = true;
						break;
					}
				}

				return hasEmailError;
			},
			getHeaderTitle( groupNumber ) {
				return +groupNumber === 1 ?
					'MAIN_CONTENT.ChangeStudentData.studentInformation' :
					'MAIN_CONTENT.ChangeStudentData.parentsGuardians';
			}
		},
		created() {
			this.$store.commit('setTitleIcon', 'file-signature');
			this.$store.commit( 'setTitle', 'MAIN_CONTENT.ChangeStudentData.sideMenuChangeStudentDataLink' );
			this.$store.commit('setUseHeader', true);

			if(this.roleRules.DATA_VERIFICATION_FLG === 'Y') {
				this.fetchStudentData();
			} else {
				this.$router.push({ name: 'HomePage' });
			}
		}
	};
</script>

<style scoped>
	.contact-header {
		margin-bottom: 0;
	}

	.rounded-top {
		border-radius: 25px 25px 0 0;
	}
</style>
